import TwoColumnLayout from "layout/TwoColumnLayout";
import { useLoaderData } from "react-router";
import React from "react";
import { FlightDetailSection } from "flights/FlightDetailSection";
import FlightOptionsPanel from "flights/FlightOptionsPanel";
import { FlightActivityPanel } from "./activity/FlightActivityPanel";
import { FlightItinerarySidebarApp } from "show/ItinerarySidebar/app";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { useIsInternal } from "common/SessionContext";

export const FlightDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightDetailFrontModel>();
  const [artist, setArtist] = React.useState<server.dto.ArtistSmall>(viewModel.sidePanelDto.flight.artist);
  const [appointmentDateTime, setAppointmentDateTime] = React.useState<server.dto.AppointmentDateTime>(viewModel.sidePanelDto.flight.dateTime);
  const [queryKey, setQueryKey] = React.useState<number>(0);
  const isInternalUser = useIsInternal();

  const linkedShowsQuery = useQuery({
    queryKey: ["linkedShowsToFlight", viewModel.sidePanelDto.flight.flightId],
    queryFn: async () => {
      const result = await window.CoreApi.Flight.GetSidePanelData(viewModel.sidePanelDto.flight.flightId);
      return result.data.data?.linkedShows ?? [];
    },
    initialData: viewModel.sidePanelDto.linkedShows,
    initialDataUpdatedAt: Date.now(),
    staleTime: Infinity,
  });

  const linkedShowsData = linkedShowsQuery.data ?? [];
  const refetchLinkedShows = async () => {
    await linkedShowsQuery.refetch();
    setQueryKey(prev => prev + 1);
  };

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FlightDetailSection
        flight={viewModel.sidePanelDto.flight}
        linkedShows={linkedShowsData}
        linkShowToTravel={{
          canLink: viewModel.sidePanelDto.flight.permissions.canModify,
          travelType: "flight",
          travelId: viewModel.sidePanelDto.flight.flightId,
          appointmentDateTime,
          artist,
          linkedShowIds: linkedShowsData.map(show => show.showId),
          onLinked: refetchLinkedShows
        }}
        passengers={viewModel.sidePanelDto.passengers}
        onArtistChanged={a => setArtist(a)}
        onStatusChanged={() => setQueryKey(prev => prev + 1)}
        onAirportChanged={() => setQueryKey(prev => prev + 1)}
        onDateChanged={d => {
          setAppointmentDateTime(d);
          setQueryKey(prev => prev + 1);
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <FlightOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        flightId={viewModel.sidePanelDto.flight.flightId}
      />
      {isInternalUser && <FlightItinerarySidebarApp
        flightId={viewModel.sidePanelDto.flight.flightId}
        artist={artist}
        startDate={moment.utc(appointmentDateTime.startDisplay)}
        endDate={moment.utc(appointmentDateTime.endDisplay)}
        linkedShowIds={linkedShowsData.map(ls => ls.showId)}
        queryKeys={`flightItinerary-${queryKey}`}
      />}
      {isInternalUser && <FlightActivityPanel
        config={viewModel.activityPanelConfig}
        flightId={viewModel.sidePanelDto.flight.flightId}
      />}
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}
